export const copyableLabelStyle = {
  c2: {
    containerBox: {
      position: 'relative',
      lineHeight: 2,
    },
    sx: (maxWidth: string, textColor: string) => ({
      color: textColor,
      display: 'inline-block',
      width: 'fit-content',
      maxWidth,
      padding: '1px 3px 1px 7px',
      '&:not(:hover) > div': {
        display: 'none',
      },
      '&:hover > div': {
        display: 'flex',
        backgroundColor: 'rgba(80, 72, 229, 0.08)',
        borderRadius: '4px',
        padding: '1px 3px 1px 7px',
      },
      '&:hover > span': {
        opacity: 0,
      },
      '&:hover > p': {
        opacity: 0,
      },
    }),
  },
  hoverLabel: {
    display: 'block',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
  },
  hoverContainer: {
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
} as const;
